(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sss-collections-story-menu"] && !Shopify.designMode) return;
  try {
    function initCollectionStoryMenus() {
    document.querySelectorAll('.sss-collections-story').forEach(menu => {
      if (menu.dataset.bound === 'true') return;
      menu.dataset.bound = 'true';
      const tabs = Array.from(menu.querySelectorAll('[data-brand-tab]'));
      const panels = Array.from(menu.querySelectorAll('[data-brand-panel]'));
      const activate = handle => {
        tabs.forEach(tab => tab.classList.toggle('is-active', tab.dataset.brandTab === handle));
        panels.forEach(panel => {
          const active = panel.dataset.brandPanel === handle;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };
      tabs.forEach(tab => {
        tab.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') activate(tab.dataset.brandTab);
        });
        tab.addEventListener('focus', () => activate(tab.dataset.brandTab));
      });
    });
  }
  initCollectionStoryMenus();
  document.addEventListener('shopify:section:load', initCollectionStoryMenus);
  } catch(e) { console.error(e); }
})();

})();
